
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
// Entities
import { Warehouse, StocksFields, Company } from "@/entities/index";

@Component
export default class FilterBar extends Vue {
  @Prop() warehouses: Array<Warehouse> = [];

  @Emit("search") search(stocksFields: StocksFields): void {}
  @Emit("downloadCSV") downloadCSV(): void {}

  optionPalette = this.company.optionPalette;

  stocksFields: StocksFields = {
    reference: "",
    palletNumber: "",
    designation: "",
    family: "",
    lot: "",
    warehouse: "",
  };

  onSearch(): void {
    this.search(this.stocksFields);
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.stocksFields = {
      reference: "",
      palletNumber: "",
      designation: "",
      family: "",
      lot: "",
      warehouse: "",
    };
  }
}
